import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["capacity", "margin", "threshold"];

  connect() {
    this.calculate();
  }

  calculate() {
    const capacity = parseFloat(this.capacityTarget.value) || 0;
    const margin = parseFloat(this.marginTarget.value) || 0;
    const threshold = capacity - margin;

    if (!threshold || threshold <= 0) {
      this.thresholdTarget.textContent = "—";
      return;
    }

    this.thresholdTarget.textContent = threshold.toFixed(1);
  }
}
